module.exports = __webpack_public_path__ + "static/media/bottom-main.2337ebdf.svg";